import React, { useState, useEffect } from "react";
import {
  Layout,
  Card,
  Table,
  Button,
  Input,
  Divider,
  Collapse,
  Row,
  Col,
  message,
  Form,
  Select,
  Tooltip,
  Checkbox,
  Spin,
} from "antd";
import IntlMessages from "../../../util/IntlMessages";
import ds from "../../../Services/DataServices";
import Skeleton from "react-loading-skeleton";
import SupplierImg from "../../../assets/images/product-supplier.png";
import { useHistory } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { InputGroup } from "reactstrap";
import { setCommonConfigs } from "../../../appRedux/actions/CommonData";
import { isEmptyObject, checkRightspermissions, notAllowMsgCheck } from "../../../appRedux/actions/GlobalMethods";
import { PRODUCT_SCREEN } from "../../../constants/Pages";
import { BEHAVIOUR_TYPE } from "../../../Services/DataServices";
import { useSelector, useDispatch } from "react-redux";
import NotAllowedComponent from "../../../components/NotAllowedComponent";

const SuppliersView = ({ match }) => {
  const history = useHistory();
  const isViewMode = match.path.split("/")[4] == "view" ? true : false;
  const urlSupplierID = parseInt(match.params.id);
  const dispatch = useDispatch();
  const [SupplierName, SetsupplierName] = React.useState({ SupplierName: "" });
  const [SupplierDescription, SetSupplierDescription] = React.useState({
    SupplierDescription: "",
  });
  const [DefaultMarkup, SetDefaultMarkup] = React.useState({
    DefaultMarkup: 0,
  });

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  );

  const [FirstName, SetFirstName] = React.useState({ FirstName: "" });
  const [LastName, SetLastName] = React.useState({ LastName: "" });
  const [CompanyName, SetCompanyName] = React.useState({ CompanyName: "" });
  const [Email, SetEmail] = React.useState({ Email: "" });
  const [PhoneNo, SetPhoneNo] = React.useState({ PhoneNo: "" });
  const [MobileNo, SetMobileNo] = React.useState({ MobileNo: "" });
  const [Website, SetWebsite] = React.useState({ Website: "" });
  const [Twitter, SetTwitter] = React.useState({ Twitter: "" });
  const [Py_street1, SetPy_street1] = React.useState({ Py_street1: "" });
  const [Py_street2, SetPy_street2] = React.useState({ Py_street2: "" });
  const [Py_subburb, SetPy_subburb] = React.useState({ Py_subburb: "" });
  const [Py_postcode, SetPy_postcode] = React.useState({ Py_postcode: "" });
  const [Py_state, SetPy_state] = React.useState({ Py_state: "" });
  const [Py_country, SetPy_country] = React.useState({ Py_country: "" });
  const [Po_street1, SetPo_street1] = React.useState({ Po_street1: "" });
  const [Po_street2, SetPo_street2] = React.useState({ Po_street2: "" });
  const [Po_subburb, SetPo_subburb] = React.useState({ Po_subburb: "" });
  const [Po_postcode, SetPo_postcode] = React.useState({ Po_postcode: "" });
  const [Po_state, SetPo_state] = React.useState({ Po_state: "" });
  const [Po_country, SetPo_country] = React.useState({ Po_country: "" });
  const [PosameasPy, SetPosameasPy] = React.useState({ PosameasPy: "" });
  const [isDeleting, SetisDeleting] = React.useState({ isDeleting: false });
  const [isLoading, SetisLoading] = React.useState({ isLoading: true });
  const [getIsDisableCreate, setIsDisableCreate] = useState(true);
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true);
  const [getIsDisableDelete, setIsDisableDelete] = useState(true);
  const [getIsAllowRead, setIsAllowRead] = useState(false);
  const [getAccessLoading, setAccessLoading] = useState(true);
  const [getRights, setRights] = useState([]);
  const [getPermissions, setPermissions] = useState([]);
  const [getCurrData, setCurrData] = useState({
    currencyCode: "",
    currencyName: "",
    currencySymbol: "",
  });

  useEffect(() => {
    dispatch(setCommonConfigs(PRODUCT_SCREEN));
    if (isViewMode) {
      ds.getSuppliers({ supplierID: urlSupplierID }, BEHAVIOUR_TYPE.GET).then((supplier) => {
        if (
          supplier != null &&
          Array.isArray(supplier.data.data) &&
          supplier.data.data.length != 0
        ) {
          let supplierFormData = supplier.data.data;

          if (supplier.data.msgCode === "GENERAL_SUCCESS") {
            ;
            SetsupplierName({ SupplierName: supplierFormData[0].supplierName });
            SetSupplierDescription({
              SupplierDescription: supplierFormData[0].supplierDescription,
            });
            SetDefaultMarkup({
              DefaultMarkup: supplierFormData[0].defaultMarkupPercentage,
            });
            SetFirstName({ FirstName: supplierFormData[0].firstName });
            SetLastName({ LastName: supplierFormData[0].lastName });
            SetCompanyName({ CompanyName: supplierFormData[0].companyName });
            SetEmail({ Email: supplierFormData[0].email });
            SetPhoneNo({ PhoneNo: supplierFormData[0].phoneNo });
            SetMobileNo({ MobileNo: supplierFormData[0].mobileNo });
            SetWebsite({ Website: supplierFormData[0].website });
            SetTwitter({ Twitter: supplierFormData[0].twitter });
            SetPy_street1({ Py_street1: supplierFormData[0].physical_Street1 });
            SetPy_street2({ Py_street2: supplierFormData[0].physical_Street2 });
            SetPy_subburb({ Py_subburb: supplierFormData[0].physical_Suburb });
            SetPy_postcode({
              Py_postcode: supplierFormData[0].physical_PostCode,
            });
            SetPy_state({ Py_state: supplierFormData[0].physical_State });
            SetPy_country({ Py_country: supplierFormData[0].phy_CountryName });
            SetPo_street1({ Po_street1: supplierFormData[0].postal_Street1 });
            SetPo_street2({ Po_street2: supplierFormData[0].postal_Street2 });
            SetPo_subburb({ Po_subburb: supplierFormData[0].postal_Suburb });
            SetPo_postcode({
              Po_postcode: supplierFormData[0].postal_PostCode,
            });
            SetPo_state({ Po_state: supplierFormData[0].postal_State });
            SetPo_country({ Po_country: supplierFormData[0].po_CountryName });
            SetPosameasPy({ PosameasPy: supplierFormData[0].isPoSameasPhy });
            //setSupplierState({ faxNo: supplierFormData[0].faxNo });
            // setSupplier(supplierFormData);
            SetisLoading({ isLoading: false });
          } else if (supplier.data.msgCode === "GENERAL_ERROR") {
            history.push("/Dashboard/products/supplier");
          }
        } else {
          history.push("/Dashboard/products/supplier");
        }
      })
        .catch((e) => {
          notAllowMsgCheck(e);
        });
    }
  }, []);

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true;
    if (mounted) {
      const commonData = getReduxCommonSetting;
      const respData = commonData &&  commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig ?
        commonData.storeCommonConfigs.storeConfig : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData;
        setCurrData(currencyData);
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData);
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData);
          setAccessLoading(false);
        } else {
          toInitialState();
          setAccessLoading(false);
        }
      }
    }

    return () => (mounted = false);
  }, [getReduxCommonSetting]);

  function setupRightsPermissions(rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights);
    } else {
      setRights([]);
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions);
    } else {
      setPermissions([]);
    }
    if (rpData.read) {
      setIsAllowRead(true);
    } else {
      setIsAllowRead(false);
    }
    if (rpData.create) {
      setIsDisableCreate(false);
    } else {
      setIsDisableCreate(true);
    }
    if (rpData.update) {
      setIsDisableUpdate(false);
    } else {
      setIsDisableUpdate(true);
    }
    if (rpData.delete) {
      setIsDisableDelete(false);
    } else {
      setIsDisableDelete(true);
    }
  }

  function toInitialState() {
    setRights([])
    setPermissions([]);
    setIsAllowRead(false);
    setIsDisableCreate(true);
    setIsDisableUpdate(true);
    setIsDisableDelete(true);
    setAccessLoading(true);
  }

  const redirectToEdit = () => {
    history.push("/Dashboard/products/supplier/edit/" + urlSupplierID);
  };
  const supplierDelete = async () => {
    ;
    SetisDeleting({ isDeleting: true });
    let addUpdateDeleteSupplier = {
      data: {
        msgCode: "",
        msgDescription: "",
      },
    };
    await ds
      .addUpdateDeleteSupplier({
        SupplierID: urlSupplierID,
        IsRemove: true,
      }, BEHAVIOUR_TYPE.DELETE)
      .then((response) => (addUpdateDeleteSupplier.data = response.data))
      .catch((e) => {
        notAllowMsgCheck(e);
      });

    if (addUpdateDeleteSupplier.data.msgCode == "GENERAL_SUCCESS") {
      message.success(addUpdateDeleteSupplier.data.msgDescription);
      history.push("/Dashboard/products/supplier");
      SetisDeleting({ isDeleting: false });
    }

    if (addUpdateDeleteSupplier.data.msgCode == "GENERAL_ERROR") {
      message.error(addUpdateDeleteSupplier.data.msgDescription);
      SetisDeleting({ isDeleting: false });
    }
  };
  const redirectToListing = () => {
    history.push("/Dashboard/products/supplier");
  };

  return getIsAllowRead ? (
    <div>
      {isLoading.isLoading ? (
        <Skeleton count={12} height={30} />
      ) : (
        <>
          <Spin tip="Deleting..." spinning={isDeleting.isDeleting}>
            <Row style={{ marginBottom: "20px", backgroundColor: "#ffff" }}>
              <div style={{ marginBottom: "10px", marginLeft: "23px" }}>
                <h1 style={{ marginTop: "20px" }}>
                  <ArrowLeftOutlined onClick={redirectToListing} />
                  {" " + SupplierName.SupplierName}
                </h1>
              </div>
            </Row>
            <Row style={{ backgroundColor: "#d6d7da38" }}>
              <Col md={6} style={{ marginTop: "15px" }}>
                <p className="title gx-mb-4">View and edit your supplier.</p>
              </Col>
              <Col md={18} style={{ marginTop: "15px" }}>
                <div style={{ textAlign: "right", marginBottom: "16px" }}>
                  <Button
                    className="custom-btn-cancel"
                    type="primary"
                    onClick={supplierDelete}
                    size="large"
                    disabled={getIsDisableDelete}
                  >
                    Delete
                  </Button>
                  <Button
                    className="custom-btn-supplier"
                    type="primary"
                    onClick={redirectToEdit}
                    size="large"
                    disabled={getIsDisableUpdate}
                  >
                    Edit
                  </Button>
                </div>
              </Col>
            </Row>
            <h2 style={{ margin: "revert" }}>
              {" "}
              {SupplierDescription.SupplierDescription}
            </h2>
            <Divider style={{ marginTop: "50px", marginBottom: "50px" }} />
            <Row>
              <Col span={12}>
                <div /*style={{ marginLeft:"41px" }}*/>
                  <div className="custom-content-row">
                    <div className="custom-content-row-space">
                      <strong>Default Markup</strong>
                    </div>
                    <p>{DefaultMarkup.DefaultMarkup}%</p>
                  </div>

                  <div className="custom-content-row">
                    <strong className="custom-content-row-space">
                      Company
                    </strong>
                    <p>{CompanyName.CompanyName}</p>
                  </div>

                  <div className="custom-content-row">
                    <strong className="custom-content-row-space">
                      Contact
                    </strong>
                    <p>
                      {FirstName.FirstName} {LastName.LastName}
                    </p>
                  </div>

                  <div className="custom-content-row">
                    <strong className="custom-content-row-space">Phone</strong>
                    <p>{PhoneNo.PhoneNo}</p>
                  </div>

                  <div className="custom-content-row">
                    <strong className="custom-content-row-space">Mobile</strong>
                    <p>{MobileNo.MobileNo}</p>
                  </div>

                  <div className="custom-content-row">
                    <strong className="custom-content-row-space">Fax</strong>
                    <p>12%</p>
                  </div>

                  <div className="custom-content-row">
                    <strong className="custom-content-row-space">Email</strong>
                    <p>{Email.Email}</p>
                  </div>

                  <div className="custom-content-row">
                    <strong className="custom-content-row-space">
                      Website
                    </strong>
                    <p>{Website.Website}</p>
                  </div>

                  <div className="custom-content-row">
                    <strong className="custom-content-row-space">
                      Twitter
                    </strong>
                    <p>{Twitter.Twitter}</p>
                  </div>
                </div>
              </Col>
              <Col span={12}>
                <div className="custom-content-row">
                  <div className="custom-content-row-space">
                    <strong>Physical Address</strong>
                  </div>

                  <ul style={{ listStyle: "none" }}>
                    <li>{Py_street1.Py_street1}</li>
                    <li>{Py_street2.Py_street2}</li>
                    <li>{Py_subburb.Py_subburb}</li>
                    <li>{Py_postcode.Py_postcode}</li>
                    <li>{Py_state.Py_state}</li>
                    <li>{Py_country.Py_country}</li>
                  </ul>
                </div>

                <div className="custom-content-row">
                  <strong className="custom-content-row-space">
                    Postal Address
                  </strong>

                  <ul style={{ listStyle: "none" }}>
                    <li>{Po_street1.Po_street1}</li>
                    <li>{Po_street2.Po_street2}</li>
                    <li>{Po_subburb.Po_subburb}</li>
                    <li>{Po_postcode.Po_postcode}</li>
                    <li>{Po_state.Po_state}</li>
                    <li>{Po_country.Po_country}</li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Spin>
        </>
      )}
    </div>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  );
};

export default SuppliersView;
